<section #dropdown class="tw-inline-flex tw-items-center tw-w-full" (click)="toggleDropdown($event)">
  <ng-content></ng-content>
</section>
